import React, { MutableRefObject, useCallback, useState } from 'react'
import { MODEL_TYPE } from '@trustero/trustero-api-web/lib/common/model_pb'
import { GRC_PLATFORM } from '@trustero/trustero-api-web/lib/common/grc_platform_pb'
import { FlexAlign, FlexColumn, FlexRow } from '../Reusable/Flex'
import { CheckBoxInput } from '../Reusable/Inputs/CheckBox'
import { getPluralization } from '../../Utils/globalHelpers'
import { getGrcPlatformLabel, getModelTypeLabel } from './ModalForm.utils'

export const ImportedRecordModalBody = ({
  modelType,
  grcPlatform,
  dismissWarning,
  setDismissWarning,
  count = 1,
}: {
  modelType: MODEL_TYPE
  grcPlatform: GRC_PLATFORM
  dismissWarning: MutableRefObject<boolean>
  setDismissWarning: (value: boolean) => void
  // How many imported records the change touches.
  count?: number
}): JSX.Element => {
  const modelTypeLabel = getModelTypeLabel(modelType)
  const grcPlatformLabel = getGrcPlatformLabel(grcPlatform)
  const [checked, setChecked] = useState<boolean>(dismissWarning.current)

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setDismissWarning(e.target.checked)
      setChecked(e.target.checked)
    },
    [setDismissWarning],
  )

  return (
    <FlexColumn gap={10} align={FlexAlign.FLEX_START}>
      {count > 1
        ? `These ${count} ${getPluralization(
            modelTypeLabel,
            count,
          )} have been imported from ${grcPlatformLabel}.
      If they change in ${grcPlatformLabel} and are imported again, the versions in ${grcPlatformLabel} will replace any changes you make here in Trustero.`
        : `This ${modelTypeLabel} has been imported from ${grcPlatformLabel}.
      If it changes in ${grcPlatformLabel} and is imported again, the version in ${grcPlatformLabel} will replace any changes you make here in Trustero.`}
      <FlexRow justify={FlexAlign.FLEX_START} gap={10}>
        <CheckBoxInput checked={checked} onChange={handleChange} />
        Don&apos;t show this warning again
      </FlexRow>
    </FlexColumn>
  )
}
